import axios from "axios";

const API_URL = "/api";

const parseJSON = response => {
  const { status, statusText } = response;
  return new Promise(resolve => {
    if (status === 404 || status === 401) {
      return resolve(getStatus(status, false, statusText));
    } else if (status === 204) {
      return resolve(getStatus(204, true, statusText));
    }
    return resolve(getStatus(status, true, response.data))
  });
};

const getStatus = (status, ok, data) => {
  return { status, ok, data };
};

export default (endpoint, method = "GET", body = {}, requireAuth = true) => {
  let headers = {};
  if (!(body instanceof FormData)) {
    body = JSON.stringify(body);
    headers = Object.assign(headers, {
      "Content-Type": "application/json",
    });
  } 
  if (requireAuth && localStorage.getItem("user")) {
    headers = Object.assign(headers, {
      Authorization: "Bearer " +  JSON.parse(localStorage.getItem("user")).token,
    });
  }
  if (["PUT", "PATCH", "DELETE"].includes(method)) {
    let param_method = method;
    body.append("_method", param_method);
    method = "POST";
  }
  let options = {
    method,
    url: API_URL + endpoint,
    data: body,
    headers,
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then(parseJSON)
      .then(res => {
        return res.ok ? resolve(res.data) : reject(res);
      })
      .catch(e => {
        return reject(e.response);
      });
  });
};
